export default "__VITE_ASSET__CSlTmLa___"